import { create, match } from "../fable-library-js.4.25.0/RegExp.js";
import { head, isEmpty, empty, tail } from "../fable-library-js.4.25.0/List.js";
import { map, delay, toList } from "../fable-library-js.4.25.0/Seq.js";
import { Union, Record } from "../fable-library-js.4.25.0/Types.js";
import { uint16_type, option_type, array_type, bool_type, tuple_type, unit_type, lambda_type, list_type, class_type, union_type, record_type, string_type } from "../fable-library-js.4.25.0/Reflection.js";
import { join, printf, toText } from "../fable-library-js.4.25.0/String.js";
import { defaultOf } from "../fable-library-js.4.25.0/Util.js";
import { FSharpResult$2 } from "../fable-library-js.4.25.0/Result.js";
import { parse } from "../fable-library-js.4.25.0/Int32.js";

export function Common_$007CRegex$007C_$007C(pattern, input) {
    const m = match(create(pattern), input);
    if (m != null) {
        return tail(toList(delay(() => map((g) => (g || ""), m))));
    }
    else {
        return undefined;
    }
}

export class Common_Name extends Record {
    constructor(given, family) {
        super();
        this.given = given;
        this.family = family;
    }
}

export function Common_Name_$reflection() {
    return record_type("Webbler.Models.Api.Common.Name", [], Common_Name, () => [["given", string_type], ["family", string_type]]);
}

export function Common_Name_create(first, last) {
    return new Common_Name(first, last);
}

export function Common_Name_display_4140EA02(name) {
    return toText(printf("%s %s"))(name.given)(name.family);
}

export function Common_Name_sanitize_4140EA02(name) {
    return new Common_Name(name.given.trim(), name.family.trim());
}

export function Common_Name_get_given_() {
    return [(m) => m.given, (v) => ((m_1) => (new Common_Name(v, m_1.family)))];
}

export function Common_Name_get_family_() {
    return [(m) => m.family, (v) => ((m_1) => (new Common_Name(m_1.given, v)))];
}

export class Common_EmailAddress extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["EmailAddress"];
    }
    toString() {
        const x = this;
        return Common_EmailAddress_value_Z39D6D3C1(x);
    }
}

export function Common_EmailAddress_$reflection() {
    return union_type("Webbler.Models.Api.Common.EmailAddress", [], Common_EmailAddress, () => [[["Item", string_type]]]);
}

export function Common_EmailAddress_create_Z721C83C5(s) {
    const str = (s !== defaultOf()) ? s.trim() : "";
    if (match(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/gu, str) != null) {
        return new FSharpResult$2(0, [new Common_EmailAddress(str)]);
    }
    else {
        return new FSharpResult$2(1, [undefined]);
    }
}

export function Common_EmailAddress_value_Z39D6D3C1(_arg) {
    return _arg.fields[0];
}

export class Security_UserViewModel$2 extends Record {
    constructor(id, email, name, roles, userData) {
        super();
        this.id = id;
        this.email = email;
        this.name = name;
        this.roles = roles;
        this.userData = userData;
    }
}

export function Security_UserViewModel$2_$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.UserViewModel`2", [gen0, gen1], Security_UserViewModel$2, () => [["id", class_type("System.Guid")], ["email", string_type], ["name", Common_Name_$reflection()], ["roles", list_type(gen0)], ["userData", gen1]]);
}

export function Security_UserViewModel$2_empty_1505(emptyUserData) {
    return new Security_UserViewModel$2("00000000-0000-0000-0000-000000000000", "", Common_Name_create("", ""), empty(), emptyUserData);
}

export function Security_UserViewModel$2_get_id_() {
    return [(m) => m.id, (v) => ((m_1) => (new Security_UserViewModel$2(v, m_1.email, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_email_() {
    return [(m) => m.email, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, v, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_name_() {
    return [(m) => m.name, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, v, m_1.roles, m_1.userData)))];
}

export function Security_UserViewModel$2_get_roles_() {
    return [(m) => m.roles, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, m_1.name, v, m_1.userData)))];
}

export function Security_UserViewModel$2_get_userData_() {
    return [(m) => m.userData, (v) => ((m_1) => (new Security_UserViewModel$2(m_1.id, m_1.email, m_1.name, m_1.roles, v)))];
}

export class Security_UserInfoError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["InvalidEmailAddress"];
    }
}

export function Security_UserInfoError_$reflection() {
    return union_type("Webbler.Models.Api.Security.UserInfoError", [], Security_UserInfoError, () => [[]]);
}

export class Security_UserInfo$2 extends Record {
    constructor(id, email, name, roles, userData) {
        super();
        this.id = id;
        this.email = email;
        this.name = name;
        this.roles = roles;
        this.userData = userData;
    }
}

export function Security_UserInfo$2_$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.UserInfo`2", [gen0, gen1], Security_UserInfo$2, () => [["id", class_type("System.Guid")], ["email", Common_EmailAddress_$reflection()], ["name", Common_Name_$reflection()], ["roles", list_type(gen0)], ["userData", gen1]]);
}

export function Security_UserInfo$2_get_id_() {
    return [(m) => m.id, (v) => ((m_1) => (new Security_UserInfo$2(v, m_1.email, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_email_() {
    return [(m) => m.email, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, v, m_1.name, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_name_() {
    return [(m) => m.name, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, v, m_1.roles, m_1.userData)))];
}

export function Security_UserInfo$2_get_roles_() {
    return [(m) => m.roles, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, m_1.name, v, m_1.userData)))];
}

export function Security_UserInfo$2_get_userData_() {
    return [(m) => m.userData, (v) => ((m_1) => (new Security_UserInfo$2(m_1.id, m_1.email, m_1.name, m_1.roles, v)))];
}

export function Security_UserInfo$2_fromViewModel_Z62CB2AC(viewModel) {
    const matchValue = Common_EmailAddress_create_Z721C83C5(viewModel.email);
    if (matchValue.tag === 0) {
        return new FSharpResult$2(0, [new Security_UserInfo$2(viewModel.id, matchValue.fields[0], viewModel.name, viewModel.roles, viewModel.userData)]);
    }
    else {
        return new FSharpResult$2(1, [new Security_UserInfoError()]);
    }
}

export function Security_UserInfo$2_toViewModel_Z3F1C2E28(userInfo) {
    return new Security_UserViewModel$2(userInfo.id, Common_EmailAddress_value_Z39D6D3C1(userInfo.email), userInfo.name, userInfo.roles, userInfo.userData);
}

export class Security_RegisterViewModel extends Record {
    constructor(email, password, givenName, familyName, roles) {
        super();
        this.email = email;
        this.password = password;
        this.givenName = givenName;
        this.familyName = familyName;
        this.roles = roles;
    }
}

export function Security_RegisterViewModel_$reflection() {
    return record_type("Webbler.Models.Api.Security.RegisterViewModel", [], Security_RegisterViewModel, () => [["email", string_type], ["password", string_type], ["givenName", string_type], ["familyName", string_type], ["roles", list_type(string_type)]]);
}

export function Security_RegisterViewModel_get_empty() {
    return new Security_RegisterViewModel("", "", "", "", empty());
}

export class Security_LoginViewModel extends Record {
    constructor(email, password) {
        super();
        this.email = email;
        this.password = password;
    }
}

export function Security_LoginViewModel_$reflection() {
    return record_type("Webbler.Models.Api.Security.LoginViewModel", [], Security_LoginViewModel, () => [["email", string_type], ["password", string_type]]);
}

export function Security_LoginViewModel_get_empty() {
    return new Security_LoginViewModel("", "");
}

export class Security_ResetPasswordViewModel extends Record {
    constructor(email, resetToken, newPassword, confirmPassword) {
        super();
        this.email = email;
        this.resetToken = resetToken;
        this.newPassword = newPassword;
        this.confirmPassword = confirmPassword;
    }
}

export function Security_ResetPasswordViewModel_$reflection() {
    return record_type("Webbler.Models.Api.Security.ResetPasswordViewModel", [], Security_ResetPasswordViewModel, () => [["email", string_type], ["resetToken", string_type], ["newPassword", string_type], ["confirmPassword", string_type]]);
}

export function Security_ResetPasswordViewModel_get_empty() {
    return new Security_ResetPasswordViewModel("", "", "", "");
}

export class Security_ChangePasswordViewModel extends Record {
    constructor(currentPassword, newPassword) {
        super();
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
    }
}

export function Security_ChangePasswordViewModel_$reflection() {
    return record_type("Webbler.Models.Api.Security.ChangePasswordViewModel", [], Security_ChangePasswordViewModel, () => [["currentPassword", string_type], ["newPassword", string_type]]);
}

export class Security_EmailChangeViewModel extends Record {
    constructor(currentEmail, newEmail, changeToken) {
        super();
        this.currentEmail = currentEmail;
        this.newEmail = newEmail;
        this.changeToken = changeToken;
    }
}

export function Security_EmailChangeViewModel_$reflection() {
    return record_type("Webbler.Models.Api.Security.EmailChangeViewModel", [], Security_EmailChangeViewModel, () => [["currentEmail", string_type], ["newEmail", string_type], ["changeToken", string_type]]);
}

export function Security_EmailChangeViewModel_get_empty() {
    return new Security_EmailChangeViewModel("", "", "");
}

export class Security_LoginResponse extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AccessToken", "ForceChangePasswordChallenge"];
    }
}

export function Security_LoginResponse_$reflection() {
    return union_type("Webbler.Models.Api.Security.LoginResponse", [], Security_LoginResponse, () => [[["jwtToken", string_type]], [["jwtToken", string_type]]]);
}

export class Security_AuthErrorMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GenericAuthError", "InvalidEmailError", "IdentityErrors", "InvalidCredentials", "ExpiredPassword", "LockedOut", "LockSelfError", "MissingUser", "NoPermission", "PasswordMismatch", "MissingClaims"];
    }
}

export function Security_AuthErrorMessage_$reflection() {
    return union_type("Webbler.Models.Api.Security.AuthErrorMessage", [], Security_AuthErrorMessage, () => [[], [["Item", string_type]], [["Item", list_type(string_type)]], [], [], [], [], [], [], [], []]);
}

export function Security_AuthErrorMessage_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? toText(printf("%s is not a valid e-mail address"))(_arg.fields[0]) : ((_arg.tag === 2) ? join(", ", _arg.fields[0]) : ((_arg.tag === 3) ? "Invalid login credentials. Please ensure you have entered the correct email address and password" : ((_arg.tag === 4) ? "Your password has expired, please request a new one" : ((_arg.tag === 5) ? "Unable to log in, user has been locked out. Please contact a site admin for assistance" : ((_arg.tag === 6) ? "Unable to lock yourself out. Please select another user" : ((_arg.tag === 7) ? "Unable to find user" : ((_arg.tag === 8) ? "You do not have permission to perform this action" : ((_arg.tag === 9) ? "Passwords do not match" : ((_arg.tag === 10) ? "Missing information for user" : "An error occurred"))))))))));
}

export class Security_PublicAuthApi extends Record {
    constructor(login, refreshToken, register, requestPasswordResetTokenEmail, resetPasswordWithToken, requestEmailChangeTokenEmail, emailChangeWithToken) {
        super();
        this.login = login;
        this.refreshToken = refreshToken;
        this.register = register;
        this.requestPasswordResetTokenEmail = requestPasswordResetTokenEmail;
        this.resetPasswordWithToken = resetPasswordWithToken;
        this.requestEmailChangeTokenEmail = requestEmailChangeTokenEmail;
        this.emailChangeWithToken = emailChangeWithToken;
    }
}

export function Security_PublicAuthApi_$reflection() {
    return record_type("Webbler.Models.Api.Security.PublicAuthApi", [], Security_PublicAuthApi, () => [["login", lambda_type(Security_LoginViewModel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Security_LoginResponse_$reflection(), Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", Security_LoginResponse_$reflection()]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["refreshToken", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["register", lambda_type(Security_RegisterViewModel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["requestPasswordResetTokenEmail", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["resetPasswordWithToken", lambda_type(Security_ResetPasswordViewModel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["requestEmailChangeTokenEmail", lambda_type(tuple_type(string_type, string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["emailChangeWithToken", lambda_type(Security_EmailChangeViewModel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))]]);
}

export class Security_SecuredAuthApi$1 extends Record {
    constructor(logout, changeUserInfo, changePassword, getUserInfo) {
        super();
        this.logout = logout;
        this.changeUserInfo = changeUserInfo;
        this.changePassword = changePassword;
        this.getUserInfo = getUserInfo;
    }
}

export function Security_SecuredAuthApi$1_$reflection(gen0) {
    return record_type("Webbler.Models.Api.Security.SecuredAuthApi`1", [gen0], Security_SecuredAuthApi$1, () => [["logout", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["changeUserInfo", lambda_type(gen0, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["changePassword", lambda_type(Security_ChangePasswordViewModel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["getUserInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))]]);
}

export class Security_SecuredUserManagementApi$2 extends Record {
    constructor(createUser, editUser, changeUserLockoutStatus, deleteUser, getUsers, getCurrentUserInfo) {
        super();
        this.createUser = createUser;
        this.editUser = editUser;
        this.changeUserLockoutStatus = changeUserLockoutStatus;
        this.deleteUser = deleteUser;
        this.getUsers = getUsers;
        this.getCurrentUserInfo = getCurrentUserInfo;
    }
}

export function Security_SecuredUserManagementApi$2_$reflection(gen0, gen1) {
    return record_type("Webbler.Models.Api.Security.SecuredUserManagementApi`2", [gen0, gen1], Security_SecuredUserManagementApi$2, () => [["createUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["editUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["changeUserLockoutStatus", lambda_type(tuple_type(gen1, bool_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["deleteUser", lambda_type(gen1, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["getUsers", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(gen0), Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(gen0)]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))], ["getCurrentUserInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(gen0), Security_AuthErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(gen0)]], [["ErrorValue", Security_AuthErrorMessage_$reflection()]]])]))]]);
}

export class Mqtt_MqttConfiguration extends Record {
    constructor(Host, Path, Port, User, Pwd, IsSecure) {
        super();
        this.Host = Host;
        this.Path = Path;
        this.Port = Port;
        this.User = User;
        this.Pwd = Pwd;
        this.IsSecure = IsSecure;
    }
}

export function Mqtt_MqttConfiguration_$reflection() {
    return record_type("Webbler.Models.Api.Mqtt.MqttConfiguration", [], Mqtt_MqttConfiguration, () => [["Host", string_type], ["Path", string_type], ["Port", uint16_type], ["User", string_type], ["Pwd", string_type], ["IsSecure", bool_type]]);
}

export function Mqtt_fromConnectionString(_arg) {
    let matchResult, hostname, path, port, pwd, uid;
    const activePatternResult = Common_$007CRegex$007C_$007C("mqtt://(.*?):(.*?)@(.*?):(.*?)/(.*)", _arg);
    if (activePatternResult != null) {
        if (!isEmpty(activePatternResult)) {
            if (!isEmpty(tail(activePatternResult))) {
                if (!isEmpty(tail(tail(activePatternResult)))) {
                    if (!isEmpty(tail(tail(tail(activePatternResult))))) {
                        if (!isEmpty(tail(tail(tail(tail(activePatternResult)))))) {
                            if (isEmpty(tail(tail(tail(tail(tail(activePatternResult))))))) {
                                matchResult = 0;
                                hostname = head(tail(tail(activePatternResult)));
                                path = head(tail(tail(tail(tail(activePatternResult)))));
                                port = head(tail(tail(tail(activePatternResult))));
                                pwd = head(tail(activePatternResult));
                                uid = head(activePatternResult);
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Mqtt_MqttConfiguration(hostname, path, parse(port, 511, true, 16), uid, pwd, false);
        default: {
            let matchResult_1, hostname_1, path_1, port_1, pwd_1, uid_1;
            const activePatternResult_1 = Common_$007CRegex$007C_$007C("mqtts://(.*?):(.*?)@(.*?):(.*?)/(.*)", _arg);
            if (activePatternResult_1 != null) {
                if (!isEmpty(activePatternResult_1)) {
                    if (!isEmpty(tail(activePatternResult_1))) {
                        if (!isEmpty(tail(tail(activePatternResult_1)))) {
                            if (!isEmpty(tail(tail(tail(activePatternResult_1))))) {
                                if (!isEmpty(tail(tail(tail(tail(activePatternResult_1)))))) {
                                    if (isEmpty(tail(tail(tail(tail(tail(activePatternResult_1))))))) {
                                        matchResult_1 = 0;
                                        hostname_1 = head(tail(tail(activePatternResult_1)));
                                        path_1 = head(tail(tail(tail(tail(activePatternResult_1)))));
                                        port_1 = head(tail(tail(tail(activePatternResult_1))));
                                        pwd_1 = head(tail(activePatternResult_1));
                                        uid_1 = head(activePatternResult_1);
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Mqtt_MqttConfiguration(hostname_1, path_1, parse(port_1, 511, true, 16), uid_1, pwd_1, true);
                default:
                    return new Mqtt_MqttConfiguration("localhost", "", 8080, "", "", false);
            }
        }
    }
}

export function Mqtt_ofTopic(topic) {
    return Array.from(map((_arg) => {
        if (_arg === ".") {
            return "/";
        }
        else {
            return _arg;
        }
    }, topic.split(""))).join('');
}

export function Mqtt_userSub(topic, uid) {
    return toText(printf("nx.%O.%s"))(uid)(topic).toLocaleLowerCase();
}

/**
 * Defines how routes are generated on server and mapped from client (used with Fable.Remoting).
 */
export function Route_builder(typeName, methodName) {
    return toText(printf("/api/%s/%s"))(typeName)(methodName);
}

